import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HeaderTemplateData } from '../dialog-data.interface';

export interface dropDownValue {
  Id: any;
  Name: string;
}

export interface content {
  dropdownValue:dropDownValue[]
}
export interface DialogData {
  header: HeaderTemplateData;
  content: content;
}

@Component({
  selector: 'selection-dialog',
  templateUrl: 'selection-dialog.html',
})
export class SelectionDialogComponent implements OnInit {
  header:HeaderTemplateData;
  content:content;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<SelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    
  ) {
    if (data) {
      this.header = data.header;
      this.content = data.content;
    }
  }

  ngOnInit() {
      this.form = new FormGroup(
        {
          selection: new FormControl('', [Validators.required])
        }
      );
  }

  onSubmit(){
    if(!this.form.invalid){
      this.dialogRef.close(this.form.value);
    }
  }
}